import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {DasUBootGameMode} from "../server/DasUBootGameMode";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {gsap} from "gsap";
import {isNewBombSymbol} from "../reels/symbols/BombSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {isTorpedoSymbol, TorpedoSymbol} from "../reels/symbols/TorpedoSymbol";

/**
 * Created by jonas on 2021-02-19.
 */

export class XBombMultiplierUpdatePresentation implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {
/*
        const torpedoSymbols:SimpleReelModelSymbolData[] = DasUBoot.reelView.getVisibleSymbolsWhere((value:SimpleReelModelSymbolData) => {
            return isTorpedoSymbol(value.positionable);
        });*/

        //It only ever 1
        const bombSymbols:SimpleReelModelSymbolData[] = DasUBoot.reelView.getVisibleSymbolsWhere((value:SimpleReelModelSymbolData) => {
            return isNewBombSymbol(value.positionable);
        });

        //Main TL
        const bombSymbol:DasUBootSymbol = <DasUBootSymbol>bombSymbols[0].positionable;
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(bombSymbol.getStateAnimation(DasUBootSymbolStates.FLASH));
        tl.add(DasUBoot.reelView.reelFrame.xBombMultiplierDisplay.incrementMultiplier(0.6, bombSymbol.getGlobalPosition(true)), "-=0.1");

        //Torpedo part upgrades.
        for (let partData of DasUBoot.model.clientData.torpedoParts) {
            const torpedoTl = gsap.timeline();
            if (partData){
                if (partData.addedThisSpin) {
                    const symbolData = DasUBoot.reelView.getVisibleSymbolAt(partData.reel, partData.addedThisSpin.position);
                    let torpedoSymbol = <TorpedoSymbol>symbolData.positionable;
                    torpedoTl.add([
                        bombSymbol.getStateAnimation(DasUBootSymbolStates.FLASH),
                        torpedoSymbol.upgradePart(partData.addedThisSpin.fallSize)
                    ]);
                    torpedoTl.add(()=>{DasUBoot.reelView.reelFrame.getFlashAnimation(0.6, bombSymbol.getGlobalPosition(true), torpedoSymbol.getGlobalPosition(true))}, "<");
                }
            }
            tl.add(torpedoTl);
        }

/*
        if (torpedoSymbols.length > 0) {
            const torpedoTl = gsap.timeline();
            for (let symbolData of torpedoSymbols) {
                let torpedoSymbol = <TorpedoSymbol>symbolData.positionable;
                torpedoTl.add([
                    bombSymbol.getStateAnimation(DasUBootSymbolStates.FLASH),
                    torpedoSymbol.upgradePart()
                ]);
                torpedoTl.add(()=>DasUBoot.winView.getFlashAnimation(0.6, bombSymbol.getGlobalPosition(true), torpedoSymbol.getGlobalPosition(true)), "<");
            }

            tl.add(torpedoTl);
        }
*/

    }


    shouldRun():boolean {
        return DasUBoot.model.gameData.nextMode == DasUBootGameMode.AVALANCHE;
    }

}